import { TableBody, TableCell, TableHead, TableRow, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import ApolloClient from "apollo-client";
import React from "react";
import { PlanosTaxasDao } from "../../../../graphql/components";
import TabelaRolavel from "../../../../componentes/Tables/TabelaRolavel";
import LinhaSemRegistros from "../../../../componentes/Tables/LinhaSemRegistros";

interface Props {
  classes?: any;
  data: Array<PlanosTaxasDao>;
  subTaxas: (client: ApolloClient<any>, codigo: number | undefined) => void;
  client: ApolloClient<any>;
}

const TabelaTaxasPorParcela = ({ classes, data, subTaxas, client }: Props) => {
  return (
    <TabelaRolavel>
      <TableHead>
        <TableRow>
          <TableCell align="right">Parcela Inicial</TableCell>
          <TableCell align="right">Parcela Final</TableCell>
          <TableCell align="right">Taxas em %</TableCell>
          <TableCell align="center">Ações</TableCell>
        </TableRow>
      </TableHead>
      {data.length === 0 ? (
        <LinhaSemRegistros colunas={4} titulo="Nenhuma taxa cadastrada" apoio="Preencha os campos acima para adicionar a primeira faixa." />
      ) : (
        <TableBody>
          {data.map(row => (
            <TableRow key={row.codplanostaxas}>
              <TableCell align="right">{row.de}</TableCell>
              <TableCell align="right">{row.ate}</TableCell>
              <TableCell align="right">{row.taxa}</TableCell>
              <TableCell align="center">
                <Tooltip title="Deletar" placement="top" onClick={() => subTaxas(client, row.codplanostaxas)}>
                  <DeleteIcon style={{ color: "gray", fontSize: 15, cursor: "pointer" }} />
                </Tooltip>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      )}
    </TabelaRolavel>
  );
};

export default TabelaTaxasPorParcela;
